import { createCRUDHook } from './createCRUDHook';
import { EventDto } from 'utils/models';
import { TBL_EVENTS } from './apiEndPoints';

const { Context, useManager, useConsumer } = createCRUDHook<EventDto>({
  entityName: 'Event',
  endpoint: TBL_EVENTS,
});

export const EventContext = Context;
export const useEventManager = useManager;
export const useEvents = useConsumer;
